import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";

import UiDialog from "components/Custom/UiDialog";
import Btn from "components/Custom/Btn";
import AutoComplete from "components/Custom/AutoComplete";
import Loader from "components/Custom/Loader";
import ExcelGrid from "components/Custom/ExcelGrid";
import TxtRow from "components/Custom/TxtRow";

import { FORMATS, NOTIFY } from "common/config";
import { COLORS } from "common/colors";
import { DEFAULTS } from "common/config";
import { LABELS, TITLES, SUCCESS, ERRORS, WARNINGS } from "common/lables";
import { COMMON_JS } from "common/scripts";
import { DateFunctions } from "common/datefunctions";
import { CUSTOMER_APIs } from "apihandlers/customer";
import { GEO_APIs } from "apihandlers/geography";

const EXCEL_GRID_ID = "Feedback";

const Feedback = (props: any) => {
  const { setDashMenu } = props;

  const beatRef: any = useRef(null);

  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [rows, setRows] = useState<any>(null);
  const [beats, setBeats] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);

  useEffect(() => {
    if (loading) {
      getArea();
    }
  }, [loading]);

  const getRows = async () => {
    try {
      const args = {
        pageNo: 1,
        pageLength: DEFAULTS.PAGE_LENGTH,
      };
      const res: any = await CUSTOMER_APIs.getFeedbacks(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1;
        }
        setRows(list);
        setLoading(false);
      }
    } catch (error) {
      console.error("getFeedbacks:", error);
    }
  };

  const getArea = () => {
    const args = {
      activeStatus: true,
    };
    GEO_APIs.getAreas(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.areaName,
          };
        });
        setBeats(list);
        getRows();
      }
    });
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
    console.log(selectedRow);
  };

  const COLUMNS = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      align: "center",
      headerAlign: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "areaName",
      name: LABELS.BEAT_PJP,
      width: "35%",
      type: "text",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "personName",
      name: LABELS.FEEDBACK_BY,
      width: "35%",
      type: "text",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "feedbackDate",
      name: LABELS.DATE,
      width: "10%",
      type: "date",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "mobileNo",
      name: LABELS.MOBILE_NUMBER,
      width: "10%",
      type: "text",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "options",
      name: "Options",
      width: "5%",
      renderCell: (params) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const manageFeedback = () => {
    const personName = (
      document.getElementById("personName") as HTMLInputElement
    ).value.trim();
    const areaId = beatRef.current.selectedValue.id;
    const mobileNo = (
      document.getElementById("mobileNo") as HTMLInputElement
    ).value.trim();
    const feedbackDate = (
      document.getElementById("feedbackDate") as HTMLInputElement
    ).value.trim();
    const feedbackDetails = (
      document.getElementById("feedbackDetails") as HTMLInputElement
    ).value.trim();

    // Validations
    let errors = [];
    if (!personName) {
      errors.push({
        id: "name",
        msg:
          "<span class='bold'>" +
          LABELS.FEEDBACK_BY +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!areaId) {
      errors.push({
        id: "sortOrder",
        msg:
          "<span class='bold'>" +
          LABELS.BEAT_PJP +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      personName: personName,
      mobileNo: mobileNo,
      feedbackDetails: feedbackDetails,
      areaId: areaId,
      feedbackDate: feedbackDate,
    };
    setIsSubmit(true);
    CUSTOMER_APIs.manageFeedback(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };

  console.log("selectedRow", selectedRow);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.HOME} </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.FEEDBACK}</li>
        </ul>
        <h4>{TITLES.FEEDBACK}</h4>
        {/* <p>{SUB_TITLES.FEEDBACK}</p> */}
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            height={window.innerHeight * 0.8}
            cols={COLUMNS}
            rows={rows}
            id={EXCEL_GRID_ID}
            hideUnhide={true}
            freezeColumn={true}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.FEEDBACK}
            onReload={reloadGrid}
            onAdd={onAdd}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + LABELS.FEEDBACK + ": " + selectedRow.personName
              : "Add New " + LABELS.FEEDBACK
          }
          open={true}
          size={"sm"}
          onClose={() => {
            setManageDialog(false);
            setMandatoryResults([]);
          }}
        >
          <div className="formGroup red">
            <label>
              {LABELS.BEAT_PJP}
              {<span className="red">*</span>}
            </label>
            <AutoComplete
              list={beats}
              childRef={beatRef}
              defaultValue={
                selectedRow.id
                  ? {
                      id: selectedRow.areaId,
                      label: selectedRow.areaName,
                    }
                  : null
              }
              onChange={(e, v) => {}}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup red">
            <TxtRow
              id={"personName"}
              type={"text"}
              label={LABELS.FEEDBACK_BY}
              required={true}
              defaultValue={selectedRow.personName}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup">
            <TxtRow
              id={"mobileNo"}
              type={"text"}
              label={LABELS.MOBILE_NUMBER}
              defaultValue={selectedRow.id ? selectedRow.mobileNo : ""}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup">
            <TxtRow
              id={"feedbackDate"}
              type={"date"}
              label={LABELS.DATE}
              defaultValue={
                selectedRow.feedbackDate
                  ? DateFunctions.getFormatedDate(
                      selectedRow.feedbackDate,
                      FORMATS.SQL_DATE,
                      FORMATS.SQL_DATE_ONLY
                    )
                  : DateFunctions.getDate(
                      "today",
                      "from",
                      FORMATS.SQL_DATE_ONLY
                    )
              }
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup">
            <TxtRow
              id={"feedbackDetails"}
              rows={4}
              type={"text"}
              label={LABELS.FEEDBACK}
              defaultValue={selectedRow.id ? selectedRow.feedbackDetails : ""}
              disabled={isSubmit}
            />
          </div>

          {/* mandatoryResults */}
          {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}

          <div className="formGroup submitBtnWrapper">
            <div className="width45 flexRowJustify">
              <Btn
                text={LABELS.SAVE}
                loading={isSubmit}
                onClick={manageFeedback}
              />
              <Btn
                text={LABELS.CANCEL}
                loading={isSubmit}
                bgColor={COLORS.DIM_DARK_GRAY}
                onClick={() => {
                  setManageDialog(false);
                  setMandatoryResults([]);
                }}
              />
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(Feedback);
